import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const AddRole = () => {
  const [teams, setTeams] = useState([]);
  const [roles, setRoles] = useState({});
  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editRoleId, setEditRoleId] = useState(null);

  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  useEffect(() => {
    fetchTeams();
  }, []);

  const fetchTeams = async () => {
    try {
      const response = await fetch("http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/teams");
      const data = await response.json();
      setTeams(data);
      data.forEach((team) => {
        fetchRoles(team._id);
      });
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };

  const fetchRoles = async (teamId) => {
    try {
      const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/roles/${teamId}`);
      const data = await response.json();
      setRoles((prev) => ({ ...prev, [teamId]: data }));
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const onSubmit = async (data) => {
    try {
      const url = editRoleId ? `http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/roles/${editRoleId}` : "http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/roles";
      const method = editRoleId ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ teamId: data.teamId, roleName: data.roleName }),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Something went wrong");

      setMessage(result.message);
      reset();
      setIsModalOpen(false);
      fetchRoles(data.teamId);
      setEditRoleId(null);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleEdit = (role) => {
    setIsModalOpen(true);
    setEditRoleId(role._id);
    reset({ teamId: role.teamId, roleName: role.roleName });
  };

  const handleDelete = async (roleId, teamId) => {
    if (!window.confirm("Are you sure you want to delete this role?")) return;

    try {
      const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/roles/${roleId}`, { method: "DELETE" });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Something went wrong");

      setMessage(result.message);
      fetchRoles(teamId);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="relative min-h-screen bg-gray-100 p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Teams & Roles</h2>
        <button onClick={() => setIsModalOpen(true)} className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
          Add Role
        </button>
      </div>

      <div className="overflow-x-auto bg-white shadow-md rounded-lg p-4">
        <table className="w-full border-collapse border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 px-4 py-2 text-left">Team</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Roles</th>
              <th className="border border-gray-300 px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {teams.length > 0 ? (
              teams.map((team) => (
                <tr key={team._id} className="border-t">
                  <td className="border border-gray-300 px-4 py-2">{team.teams}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {roles[team._id]?.length > 0 ? (
                      roles[team._id].map((role) => (
                        <span key={role._id} className="inline-flex items-center bg-gray-200 text-gray-800 px-2 py-1 rounded-md mr-2 mb-1">
                          {role.roleName}
                        </span>
                      ))
                    ) : (
                      <span className="text-gray-500">No roles added</span>
                    )}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {roles[team._id]?.length > 0 &&
                      roles[team._id].map((role) => (
                        <div key={role._id} className="inline-flex items-center space-x-2">
                          <button
                            onClick={() => handleEdit(role)}
                            className="bg-yellow-500 text-white px-2 py-1 rounded-md hover:bg-yellow-600"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(role._id, team._id)}
                            className="bg-red-500 text-white px-2 py-1 rounded-md hover:bg-red-600"
                          >
                            Delete
                          </button>
                        </div>
                      ))}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4 text-gray-500">No teams added yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-xl shadow-lg w-96">
            <h2 className="text-2xl font-bold mb-4">{editRoleId ? "Edit Role" : "Add Role"}</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <select {...register("teamId", { required: "Team is required" })} className="w-full p-2 border border-gray-300 rounded-md mb-2">
                <option value="">Select a Team</option>
                {teams.map((team) => (
                  <option key={team._id} value={team._id}>
                    {team.teams}
                  </option>
                ))}
              </select>
              {errors.teamId && <p className="text-red-500 text-sm">{errors.teamId.message}</p>}

              <input
                type="text"
                {...register("roleName", { required: "Role name is required" })}
                placeholder="Enter role name"
                className="w-full p-2 border border-gray-300 rounded-md"
              />
              {errors.roleName && <p className="text-red-500 text-sm">{errors.roleName.message}</p>}

              <div className="flex justify-end gap-4 mt-4">
                <button type="button" onClick={() => setIsModalOpen(false)} className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400">
                  Cancel
                </button>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
                  {editRoleId ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {message && <p className="mt-4 text-green-600">{message}</p>}
    </div>
  );
};

export default AddRole;
